import React from "react";

const ThemeContext = React.createContext();
const ThemeProvider = ThemeContext.Provider;
const ThemeConsumer = ThemeContext.Consumer;

const Theme = {
  dark: "theme_dark",
};

ThemeContext.displayName = "Theme.Context";

export { ThemeContext, ThemeProvider, ThemeConsumer, Theme };
